import { ResourceSearchKeyType } from '~/api/oneBoxV3/oneBoxV3.type';

export const getStoredSearchCondition = (): ResourceSearchKeyType => {
  try {
    const storedValue = localStorage.getItem('resourceSearchKey');
    return storedValue
      ? (JSON.parse(storedValue) as ResourceSearchKeyType)
      : {};
  } catch (e) {
    console.error('Failed to parse resourceSearchKey from localStorage', e);
    return {};
  }
};
